import PoiMap from 'components/maps/PoiMap';
import { X } from 'kzv-icons';
import React from 'react';
import useSWR from 'swr';

import Button from '../buttons/Button';
import { poiZoomValue } from '../maps/settings';
import BaseModal from './BaseModal';
import Poi from 'models/Poi';

interface MapModalProps {
    isOpen: boolean;
    handleClose: () => void;
    selectedPoi: Poi;
}

function MapModal({ isOpen, handleClose, selectedPoi }: MapModalProps) {
    const { data: pois, isValidating: isFetchingData } = useSWR('/public/map-query');

    return (
        <BaseModal open={isOpen} handleClose={handleClose}>
            <div className="w-full h-full md:w-[80vw] md:h-[80vh] relative">
                <PoiMap
                    pois={pois?.data}
                    isLoading={isFetchingData}
                    viewportPreset={{
                        latitude: selectedPoi.location.lat,
                        longitude: selectedPoi.location.lng,
                        zoom: poiZoomValue
                    }}
                />
                <div className="absolute md:hidden bottom-6 text-center w-full">
                    <Button variant="contained" color="white" onClick={handleClose} endIcon={<X />}>
                        Zapri zemljevid
                    </Button>
                </div>
            </div>
        </BaseModal>
    );
}

MapModal.propTypes = {};

export default MapModal;
